function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "share-fill-white");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "share-fill-white",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M9.89998188,23 C9.43671155,25.2822403 7.41895791,27 5,27 C2.23857625,27 0,24.7614237 0,22 C0,19.2385763 2.23857625,17 5,17 C5.46176084,17 5.90890182,17.062595 6.3334006,17.1797628 L10.8791016,9.90664126 C9.73367303,8.99039771 9,7.58087812 9,6 C9,3.23857625 11.2385763,1 14,1 C16.7614237,1 19,3.23857625 19,6 C19,8.76142375 16.7614237,11 14,11 C13.5382392,11 13.0910982,10.937405 12.6665994,10.8202372 L8.12089843,18.0933587 C9.01819263,18.8111163 9.66280551,19.8315818 9.89998188,21 L18.1000181,21 C18.5632884,18.7177597 20.5810421,17 23,17 C25.7614237,17 28,19.2385763 28,22 C28,24.7614237 25.7614237,27 23,27 C20.5810421,27 18.5632884,25.2822403 18.1000181,23 L9.89998188,23 Z",
  id: "Combined-Shape",
  fill: "#FFFFFF"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    version: 1.1
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/share-fill.3bdd33e7.svg";
export { SvgComponent as ReactComponent };